import axios from "axios";
import {url_local} from '../url'
//import state from "../../store";
import state from '../../store/index'


export function GetExeptions() {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.get(`${url_local}exeptions`, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al cargar la excepcion" + err);
        });
    });
    }


    export function SubirExeptions(form) {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.post(`${url_local}exeptions`,form ,config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al subir las excepcion" + err);
            });
        });
        }


    
    

